module.exports = __webpack_public_path__ + "static/media/icon-pedido.b69dea92.webp";